import { render, staticRenderFns } from "./DialogForCustomVip.vue?vue&type=template&id=f010d3a4&scoped=true"
import script from "./DialogForCustomVip.vue?vue&type=script&lang=js"
export * from "./DialogForCustomVip.vue?vue&type=script&lang=js"
import style0 from "./DialogForCustomVip.vue?vue&type=style&index=0&id=f010d3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f010d3a4",
  null
  
)

export default component.exports